namespace $ {
	/** Real modules and explicit folders only; never synthesize FQN namespace nodes. */
	export class $shm_hitalama_components_tree {
		readonly nodes = new Map< string, string[] >
		readonly definitions: Set< string >
		readonly roots: string[]
		readonly parents = new Map< string, string >
		constructor( names: readonly string[], folders: readonly { id: string, parent: string }[] = [], locations: ReadonlyMap< string, string > = new Map, orders: ReadonlyMap< string, readonly string[] > = new Map ) {
			this.definitions = new Set( names )
			const roots: string[] = []
			for( const name of [ ...this.definitions ].sort() ) {
				this.nodes.set( name, [] )
			}
			const groups = new Map( folders.map( folder => [ folder.id, folder.parent ] ) )
			for( const id of groups.keys() ) this.nodes.set( id, [] )
			for( const [ id, parent ] of groups ) {
				// Corrupt/concurrently cyclic folder ancestry must not hide data or recurse forever.
				const seen = new Set([ id ])
				let cursor = parent
				while( cursor && !seen.has( cursor ) ) { seen.add( cursor ); cursor = groups.get( cursor ) ?? '' }
				const siblings = cursor ? roots : this.nodes.get( parent ) ?? roots
				siblings.push( id )
				this.parents.set( id, cursor || !groups.has( parent ) ? '' : parent )
			}
			for( const name of [ ...this.definitions ].sort() ) {
				let siblings = roots
				const folder = locations.get( name )
				let parent_id = folder && groups.has( folder ) ? folder : ''
				for( let index = name.lastIndexOf( '_' ); index > 0; index = name.lastIndexOf( '_', index - 1 ) ) {
					const parent = this.nodes.get( name.slice( 0, index ) )
					if( !parent ) continue
					parent_id = name.slice( 0, index )
					break
				}
				siblings = this.nodes.get( parent_id ) ?? roots
				this.parents.set( name, parent_id )
				siblings.push( name )
			}
			this.roots = roots
			for( const [ parent, siblings ] of [ [ '', roots ] as const, ...this.nodes ] ) {
				const order = orders.get( parent ) ?? []
				const ranks = new Map( order.map( ( id, index ) => [ id, index ] ) )
				siblings.sort( ( left, right ) => ( ranks.get( left ) ?? order.length ) - ( ranks.get( right ) ?? order.length ) )
			}
		}
		children( id: string ) { return this.nodes.get( id ) ?? [] }
		movable( id: string ) { return this.nodes.has( id ) && !this.parents.get( id )?.startsWith( '$' ) }
	}
}
